import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "rounded-xl border border-slate-200 bg-slate-50 p-4"
};
const _hoisted_2 = {
  class: "mt-3 flex justify-end"
};
const _hoisted_3 = ["disabled"];
import { computed } from 'vue';
import { buildContinueResume } from '../../composables/agentProtocol';
export default {
  __name: 'InterruptedCard',
  props: {
    snapshot: {
      type: Object,
      required: true
    },
    pending: {
      type: Boolean,
      default: false
    }
  },
  emits: ['resume'],
  setup(__props) {
    const continuePayload = computed(() => buildContinueResume().payload);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("p", {
        class: "text-sm font-semibold text-slate-800"
      }, "执行中断（服务重启）", -1)), _cache[2] || (_cache[2] = _createElementVNode("p", {
        class: "mt-1 text-sm text-slate-600"
      }, "任务状态完好，可从断点继续执行", -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("button", {
        class: "btn-primary form-control-sm",
        disabled: __props.pending,
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('resume', continuePayload.value))
      }, _toDisplayString(__props.pending ? '恢复中…' : '继续执行'), 9, _hoisted_3)])]);
    };
  }
};